import { Component } from '@verndale/core';

class SkipNavigation extends Component {
  setupDefaults() {
    this.dom = {
      mainContainer: document.querySelector('#main'),
      skipNav: this.el
    };
  }

  addListeners() {
    this.dom.skipNav.addEventListener('click', this.handleSkipNavClick.bind(this));
  }

  handleSkipNavClick(e) {
    e.preventDefault();
    const masthead = this.dom.mainContainer.firstElementChild;
    const paddingTopValue = parseInt(window.getComputedStyle(masthead).paddingTop, 10);
    window.scrollTo(0, paddingTopValue);
  }

}

export default SkipNavigation;
